/**
 * The red zone rule, shared by the client (re-exported from
 * src/client/lib/scoring.js) and the server-side monthly summary email, so the
 * watch list in the app and in the email can never disagree.
 */

/** True when a score sits at or below the threshold. */
function isRedZone(score, threshold) {
  return threshold != null && score != null && score > 0 && score <= threshold;
}

module.exports = { isRedZone };
